import { render, staticRenderFns } from "./BannerLogos.vue?vue&type=template&id=6bc01da6"
import script from "./BannerLogos.vue?vue&type=script&lang=js"
export * from "./BannerLogos.vue?vue&type=script&lang=js"
import style0 from "./BannerLogos.vue?vue&type=style&index=0&id=6bc01da6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports